import axios from "axios";
import { SERVER_URL } from "Constants";
import BusinessDetailEntity from "Models/Entities/BusinessDetailEntity";
import { customerMonitoredStatus } from "Models/Enums";
import { RegistrationSummary } from "Views/Components/Intel/Customer/PpsrRegistrationTypes";
import { ApproveSummary } from "Views/Components/Intel/Dashboard/DashboardBrownfieldProducts";

export type AddPaygCustomerRequest = {
	customerId: string;
	businessId: string;
	monitorPricePaygAmountId: string;
}

export const EmptyCustomerSummary: CustomerSummary = {
	currentValue: 0,
	maxValue: 0,
}

export interface CustomerSummary {
	currentValue: number;
	maxValue: number;
}

export interface BusinessEntityPpsrSummary {
	ppsrSummary?: RegistrationSummary,
	errorMessage: string,
	errors: {
		[key: string]: string,
	},
}

export interface BusinessEntityApproveSummary {
	approveSummary?: ApproveSummary,
	errorMessage: string,
	errors: {
		[key: string]: string,
	},
}

export async function apiAddPaygCustomer(request: AddPaygCustomerRequest) {

	const url = `${SERVER_URL}/api/entity/CustomerEntity/add-payg`;
	return await axios.post<object>(url, request);
}

export async function apiUpdateCustomerMonitoredStatus(customerId: string, monitoredStatus: customerMonitoredStatus) {
	const url = `${SERVER_URL}/api/entity/CustomerEntity/monitored-status/${customerId}/${monitoredStatus}`;
	return await axios.post<object>(url);
}

export async function getOrganisationApproveSummary() {
	const url = `${SERVER_URL}/api/entity/CustomerEntity/business-entities/approve-summary`;
	return await axios.get<BusinessEntityApproveSummary>(url);
}


export async function getOrganisationCustomerSummary() {
	const url = `${SERVER_URL}/api/entity/CustomerEntity/customers-summary`;
	return await axios.get<CustomerSummary>(url);
}


export async function getOrganisationPpsrSummary() {
	const url = `${SERVER_URL}/api/entity/CustomerEntity/business-entities/ppsr-summary`;
	return await axios.get<BusinessEntityPpsrSummary>(url);
}

export type CustomerBusinessDetail = {
	customerId: string;
	abnAcnDetail: BusinessDetailEntity;
	trusteeDetail?: BusinessDetailEntity;
}

export async function getCustomerBusinessDetails(id: string) {
	const url = `${SERVER_URL}/api/entity/CustomerEntity/${id}/business-details`;
	return await axios.get<CustomerBusinessDetail>(url);
}

